import { Link } from "react-router-dom";
import { Instagram, Music2, MapPin, Star } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "../data/business";
import { Logo } from "./Navbar";

export default function Footer() {
  return (
    <footer className="bg-leaf-deep text-cream grain relative" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 pt-16 pb-28 md:pb-12 grid gap-12 md:grid-cols-3">
        <div>
          <Logo dark />
          <p className="mt-4 text-cream/70 text-sm leading-relaxed max-w-xs">
            {BUSINESS.tagline}. Bakso urat jumbo, tetelan goreng renyah, dan mie yamin ala Bandung — diracik fresh di dapur terbuka kami.
          </p>
          <div className="mt-5 flex gap-3">
            <a href={BUSINESS.links.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" aria-label="Instagram Bakso Tujuh Pemuda" className="w-10 h-10 rounded-full bg-cream/10 hover:bg-terracotta flex items-center justify-center transition-colors duration-300">
              <Instagram size={18} />
            </a>
            <a href={BUSINESS.links.tiktok} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok-link" aria-label="TikTok Bakso Tujuh Pemuda" className="w-10 h-10 rounded-full bg-cream/10 hover:bg-terracotta flex items-center justify-center transition-colors duration-300">
              <Music2 size={18} />
            </a>
            <a href={BUSINESS.links.maps} target="_blank" rel="noopener noreferrer" data-testid="footer-maps-link" aria-label="Bakso Tujuh Pemuda di Google Maps" className="w-10 h-10 rounded-full bg-cream/10 hover:bg-terracotta flex items-center justify-center transition-colors duration-300">
              <MapPin size={18} />
            </a>
            <a href={BUSINESS.links.googleReview} target="_blank" rel="noopener noreferrer" data-testid="footer-review-link" aria-label="Beri ulasan di Google" className="w-10 h-10 rounded-full bg-cream/10 hover:bg-terracotta flex items-center justify-center transition-colors duration-300">
              <Star size={18} />
            </a>
          </div>
        </div>
        <nav aria-label="Navigasi footer">
          <h2 className="font-display font-bold text-lg">Jelajahi</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-${l.testid}`} className="text-cream/70 hover:text-amberbrand transition-colors duration-300">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <a href={BUSINESS.links.linktree} target="_blank" rel="noopener noreferrer" data-testid="footer-linktree-link" className="text-cream/70 hover:text-amberbrand transition-colors duration-300">
                Linktree Resmi
              </a>
            </li>
          </ul>
        </nav>
        <div>
          <h2 className="font-display font-bold text-lg">Kunjungi Kami</h2>
          <address className="mt-4 not-italic text-sm text-cream/70 leading-relaxed" data-testid="footer-address">
            {BUSINESS.name}
            <br />
            {BUSINESS.address.full}
            <br />
            <span className="text-cream/50">{BUSINESS.address.landmark}</span>
          </address>
          <p className="mt-3 text-sm text-cream/70" data-testid="footer-hours">{BUSINESS.hoursLabel}</p>
          <a href={`tel:${BUSINESS.phoneIntl}`} data-testid="footer-phone-link" className="mt-1 inline-block text-sm text-cream/70 hover:text-amberbrand transition-colors duration-300">
            {BUSINESS.phoneDisplay} (WhatsApp)
          </a>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-6xl mx-auto px-4 py-5 text-xs text-cream/50 flex flex-col sm:flex-row gap-2 justify-between">
          <span>© {new Date().getFullYear()} {BUSINESS.name}. Seluruh hak cipta dilindungi.</span>
          <span>Berdiri {BUSINESS.established} · Bersertifikat Halal</span>
        </div>
      </div>
    </footer>
  );
}
